import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

import {
  REPORTING_WORKSPACES_PATH,
  ReportingApiResponseBody,
  WorkspaceResponse,
} from '@digital-platform/reporting/domain';
import {
  SHOULD_ATTACH_ACCESS_TOKEN,
  SHOULD_ATTACH_REPORTING_API_KEY,
  SHOULD_ATTACH_X_ID_TOKEN,
} from '@digital-platform/rs-signup/services';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceService {
  private readonly httpClient = inject(HttpClient);

  /**
   * Get Workspaces as an Observable
   */
  public getWorkspaces(): Observable<
    ReportingApiResponseBody<WorkspaceResponse>
  > {
    const context = new HttpContext()
      .set(SHOULD_ATTACH_ACCESS_TOKEN, true)
      .set(SHOULD_ATTACH_X_ID_TOKEN, false)
      // API key only needed for local development. API Proxy will attach
      // API key in other environments.
      .set(SHOULD_ATTACH_REPORTING_API_KEY, true);

    return this.httpClient
      .get(`${REPORTING_WORKSPACES_PATH}`, {
        context,
        observe: 'response',
      })
      .pipe(
        take(1),
        map(
          (response) =>
            response as unknown as ReportingApiResponseBody<WorkspaceResponse>
        ),
        catchError((err: Error) => throwError(() => err))
      );
  }
}
